import Vue from 'vue'
import router from '@/router'
import store from '@/store'
import axios from 'axios'
import http from './httpRequest'
const ssoHttp = axios.create({ //登录基础平台
  timeout: 1000 * 30,
  withCredentials: true,
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    'Content-Type': 'application/json; charset=utf-8'
  }
})
/**
 * 获取uuid
 */
export function getUUID() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    return (c === 'x' ? (Math.random() * 16 | 0) : ('r&0x3' | '0x8')).toString(16)
  })
}

/**
 * 树形数据转换
 * @param {*} data
 * @param {*} id
 * @param {*} pid
 */
export function treeDataTranslate(data, id = 'id', pid = 'parentId') {
  var res = []
  var temp = {}
  for (var i = 0; i < data.length; i++) {
    temp[data[i][id]] = data[i]
  }
  for (var k = 0; k < data.length; k++) {
    if (temp[data[k][pid]] && data[k][id] !== data[k][pid]) {
      if (!temp[data[k][pid]]['children']) {
        temp[data[k][pid]]['children'] = []
      }
      if (!temp[data[k][pid]]['_level']) {
        temp[data[k][pid]]['_level'] = 1
      }
      data[k]['_level'] = temp[data[k][pid]]._level + 1
      temp[data[k][pid]]['children'].push(data[k])
    } else {
      res.push(data[k])
    }
  }
  return res
}


function getAuthTokenKey() {
  let code = window.SITE_CONFIG.authtoken
  if (code === undefined || code === '') {
    code = 'authtoken'
  }
  return code
}

export function checkLoginFromSso(next) {
  let ssoHttp = axios.create({
    timeout: 1000 * 30,
    withCredentials: true,
    baseURL: '/sso',
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'Content-Type': 'application/json; charset=utf-8'
    }
  })
  ssoHttp({
    url: '/oauth/authorize',
    method: 'get'
  }).then(({data}) => {
    if (data && data.code === "1") {
      loginByJwt(data.data, function (args, result) {
        if (result.code == '1') {
          next()
        } else {
          console.log('单点服务器验证登录结果：', data)
          next({name: 'login'})
        }
      })
    } else {
      next({name: 'login'})
    }
  }).catch((e) => {
    console.log(`%c${e} 验证单点登录失败，跳转至登录页！！`, 'color:blue')
    next({name: 'login'})
  })
}

export function loginByJwt(token, nextCallBack) {
  ssoHttp.post('/sso/oauth/tokenLogin?token=' + token, {
    token: token
  }).then(({data}) => {
    console.log('本地根据token登录的结果：', data)
    if (data.code == 1) {
      Vue.cookie.set(getAuthTokenKey(), token)
      nextCallBack(data)
    } else {
      nextCallBack(data)
    }
  }).catch((e) => {
    console.log(e)
    nextCallBack({code: '1000', msg: '操作失败'})
  })
}

export function hasAuthToken() {
  let token = Vue.cookie.get(getAuthTokenKey())
  if (!token || !/\S/.test(token)) {
    return false
  }
  return true
}

/**
 * 时间转换，去 UTC+8 。默认时间不需要时区(只有在时间重新构造时才处理)
 * @param date
 */
export function parseToDate(date) {
  if (date === undefined || date === null) {
    date = new Date()
  } else if (date instanceof Date) {
    return date
  } else {
    date = new Date(date)
  }
  return new Date(date - date.getTimezoneOffset())
}


/**
 * 时间转换，去 UTC+8 。默认时间不需要时区
 * @param date
 * @param useRaw
 */
export function getMonth(date, useRaw) {
  return parseToDate(date).getMonth() + 1
}

/**
 * 时间转换，去 UTC+8 。默认时间不需要时区
 * @param date 当前时间
 * @param offsetMonth 月份便宜
 */
export function getFullMonth(date, offsetMonth) {
  var cur = parseToDate(date);
  if (offsetMonth !== undefined && offsetMonth !== 0) {
    cur = addMonth(cur, offsetMonth)
  }
  return cur.getFullYear() * 100 + cur.getMonth() + 1
}

/**
 * 时间转换，去 UTC+8 。默认时间不需要时区
 * @param date
 */
export function getYear(date) {
  return parseToDate(date).getFullYear()
}

/**
 * 时间转换，去 UTC+8 。默认时间不需要时区
 * @param date
 * @param count
 */
export function addMonth(date, count) {
  var newDate
  if (date instanceof Date) {
    newDate = new Date(date)
  } else {
    newDate = new Date(parseToDate(date))
  }
  newDate.setMonth(newDate.getMonth() + count)
  return newDate
}


//设置默认日期
export function getMonthPickDefaultDate() {
  //获取新的时间(2019.4.12）
  let date = parseToDate()
  let fromDate = addMonth(date, -6)
  let endDate = addMonth(date, 1)
  //字符串拼接，开始时间，结束时间
  var month = fromDate.getMonth() + 1;
  let beg = fromDate.getFullYear() + '-' + (month < 10 ? '0' : '') + month
  month = endDate.getMonth() + 1;
  let end = endDate.getFullYear() + '-' + (month < 10 ? '0' : '') + month
  return [beg, end] //将值设置给插件绑定的数据
}

/**
 * 将日期选择的月度范围 转换为 统计要求的 [20190101,20190101]格式
 * @param value
 */
export function parseMonthPickValue(value) {
  if (value === undefined || value.length < 2 || value[0] === undefined || value[1] === undefined) {
    value = getMonthPickDefaultDate()
  }
  var fromDate = value[0]
  var endDate = value[1]
  let result = {}
  if (fromDate.length <= 7) {
    fromDate = fromDate + '-' + '01'
    result.from = getFullMonth(fromDate)
  } else {
    result.from = getFullMonth(new Date(fromDate))
  }
  if (endDate.length <= 7) {
    endDate = endDate + '-' + '01'
    result.end = getFullMonth(endDate, 1)
  } else {
    result.end = getFullMonth(new Date(endDate), 1)
  }
  return result
}


/**
 * JS获取URL中参数值
 * @param name
 * @returns {string|null}
 */
export function getQueryString(name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
  var r = window.location.search.substr(1).match(reg);
  if (r != null) {
    return unescape(r[2]);
  }
  return null;
}

export function isIEBrowser() {
  //判断是否为IE内核浏览器
  var u = window.navigator.userAgent.toLocaleLowerCase();
  var msie = /(msie) ([\d.]+)/;
  var chrome = /(chrome)\/([\d.]+)/;
  var firefox = /(firefox)\/([\d.]+)/;
  var safari = /(safari)\/([\d.]+)/;
  var opera = /(opera)\/([\d.]+)/;
  var ie11 = /(trident)\/([\d.]+)/;
  var b = u.match(msie)||u.match(chrome)||u.match(firefox)||u.match(safari)||u.match(opera)||u.match(ie11);
  if(b[1] == "msie" || b[1] == 'trident'){
    return true;
  }else{
    return false;
  }
};

/**
 * 校验手机号
 * @param name
 * @returns {string|null}
 */
export function checkPhone(rule, value, callback) {
  if (!value) {
    callback(new Error('请输入手机号'));
  } else {
    const reg = /^1[3|4|5|7|8|9][0-9]\d{8}$/
    if (reg.test(value)) {
      callback()
    } else {
      return callback(new Error('请输入正确的手机号'))
    }
  }
}
/**
 * 校验身份证号
 * @param name
 * @returns {callback}
 */
export function isIdentityId(rule,value,callback) {
  if(!value){
    callback(new Error('请输入身份证号'));
  }else{
    var patrn = /(^\d{15}$)|(^\d{17}(\d|X|x)$)/;//长度或格式校验
    //地区校验
    var aCity = {
      11: "北京",
      12: "天津",
      13: "河北",
      14: "山西",
      15: "内蒙古",
      21: "辽宁",
      22: "吉林",
      23: "黑龙江",
      31: "上海",
      32: "江苏",
      33: "浙江",
      34: "安徽",
      35: "福建",
      36: "江西",
      37: "山东",
      41: "河南",
      42: "湖北",
      43: "湖南",
      44: "广东",
      45: "广西",
      46: "海南",
      50: "重庆",
      51: "四川",
      52: "贵州",
      53: "云南",
      54: "西藏",
      61: "陕西",
      62: "甘肃",
      63: "青海",
      64: "宁夏",
      65: "新疆",
      71: "台湾",
      81: "香港",
      82: "澳门",
      91: "国外"
    };
    // 出生日期验证
    var sBirthday = (
            value.substr(6, 4) +
            "-" +
            Number(value.substr(10, 2)) +
            "-" +
            Number(value.substr(12, 2))
        ).replace(/-/g, "/"),
        d = new Date(sBirthday)
    // 身份证号码校验 最后4位  包括最后一位的数字/字母X
    var sum = 0,
        weights = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2],
        codes = "10X98765432";
    for (var i = 0; i < value.length - 1; i++) {
      sum += value[i] * weights[i];
    }
    var last = codes[sum % 11]; //计算出来的最后一位身份证号码
    var errorMsg = '';
    if (value == '') {
     return callback(new Error("身份证号不能为空"));
    } else if (!patrn.exec(value)) {
      return callback(new Error("你输入的身份证长度或格式错误"));
    } else if (!aCity[parseInt(value.substr(0, 2))]) {
      return callback(new Error("你的身份证地区非法"));
    } else if (sBirthday != d.getFullYear() + "/" + (d.getMonth() + 1) + "/" + d.getDate()) {
      return callback(new Error("身份证上的出生日期非法"));
    } else if (value[value.length - 1] != last) {
      return callback(new Error("你输入的身份证号非法"));
    }else{
      return callback();
    }
  }

}
